/* eslint-disable react/display-name */
import styles from "./Transition.module.scss";

import { Portal } from "react-portal";
import combineClasses from "helpers/combine-classes";
import React, { forwardRef, FunctionComponent } from "react";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import isBrowserContext from "helpers/isBrowserContext";

const Transition: FunctionComponent<any> = forwardRef<HTMLDivElement, any>((props, ref) => {
    const { inViewClasses } = setInViewClasses(styles);

    const node = isBrowserContext() && document ? document.getElementById("wrapper") : undefined;

    return (
        <Portal node={node}>
            <div className={combineClasses(styles.wrapper, inViewClasses)} ref={ref}></div>
        </Portal>
    );
});

export default Transition;